import { Box, TextField, MenuItem } from '@mui/material';
import type { WaitStep } from '../../types/steps';

type Props = {
  step: WaitStep;
  onChange: (updates: Partial<WaitStep>) => void;
};

const DURATION_UNITS = [
  { value: 1, label: 'Milliseconds' },
  { value: 1000, label: 'Seconds' },
  { value: 60000, label: 'Minutes' }
] as const;

const getUnit = (ms: number) => {
  if (ms % 60000 === 0) return 60000;
  if (ms % 1000 === 0) return 1000;
  return 1;
};

export const WaitDurationForm = ({ step, onChange }: Props) => {
  const unit = getUnit(step.durationMs);
  const displayValue = step.durationMs / unit;

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2, pt: 1 }}>
      <TextField
        label="Label"
        size="small"
        fullWidth
        value={step.label ?? ''}
        onChange={e => onChange({ label: e.target.value })}
        placeholder="e.g. Wait for settle time"
      />
      <Box sx={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 2 }}>
        <TextField
          label="Duration"
          size="small"
          type="number"
          value={displayValue}
          onChange={e =>
            onChange({ durationMs: Number(e.target.value) * unit })
          }
          inputProps={{ min: 0 }}
        />
        <TextField
          label="Unit"
          size="small"
          select
          value={unit}
          onChange={e => {
            const newUnit = Number(e.target.value);
            onChange({ durationMs: displayValue * newUnit });
          }}
        >
          {DURATION_UNITS.map(u => (
            <MenuItem key={u.value} value={u.value}>
              {u.label}
            </MenuItem>
          ))}
        </TextField>
      </Box>
    </Box>
  );
};
